import { useMemo } from "react";

import { useDispatch } from "react-redux";

import { translate } from "app/filters/i18nFilter";
import { deleteMenuItem, renameMenuItem } from "app/pages/sales-intelligence/common-components/options-menu/items";
import type { MenuItemOption } from "app/pages/sales-intelligence/common-components/options-menu/types";
import { ListHookOption } from "app/pages/sales-intelligence/modules/lists/components/ListHookOption/ListHookOption";
import salesSettingsHelper from "app/pages/sales-intelligence/services/salesSettingsHelper";

import useCurrentStaticList from "../../hooks/useCurrentStaticList";
import { listDeleteModalOpenSetAction, listRenameModalOpenSetAction } from "../../store/action-creators";
import { OpportunityListTypeEnum } from "../../types";

import { StyledListOptionsMenu } from "./styles";

type Props = {
    onSelect?(option: MenuItemOption): void;
};

const ListOptionsDropdownContainer = (props: Props) => {
    const dispatch = useDispatch();
    const list = useCurrentStaticList();
    const canDeleteOpportunities = salesSettingsHelper.canDeleteOpportunities();

    const isRestrictedList =
        list?.listType === OpportunityListTypeEnum.Shared || list?.listType === OpportunityListTypeEnum.RecentlyViewed;

    const menuItems = useMemo(() => {
        return isRestrictedList ? [] : [renameMenuItem, { ...deleteMenuItem, disabled: !canDeleteOpportunities }];
    }, [isRestrictedList, canDeleteOpportunities]);

    function handleOptionClick(option: MenuItemOption) {
        props.onSelect?.(option);

        switch (option) {
            case "rename":
                return dispatch(listRenameModalOpenSetAction(true));
            case "delete":
                return dispatch(listDeleteModalOpenSetAction(true));
            default:
                return;
        }
    }

    if (menuItems.length === 0) {
        return null;
    }

    return (
        <StyledListOptionsMenu
            id="static-list-options-menu"
            items={menuItems}
            placement="bottom-left"
            tooltipContent={translate("si.static-lists.options-dd.button")}
            onSelect={handleOptionClick}
            children={!canDeleteOpportunities ? <ListHookOption /> : undefined}
            dropdownWidth={!canDeleteOpportunities ? 320 : 211}
            isAppendToBody={false}
        />
    );
};

export default ListOptionsDropdownContainer;
